import { ReactNode, useState } from 'react';
import { BordButton } from 'bord-design-system';
import ConfirmActionModal from '../ConfirmActionModal/ConfirmActionModal';

import './ActionButtons.scss';

interface ITwoButtonRowProps {
  children: ReactNode;
  className?: string;
}

const TwoButtonRow = ({ children, className }: ITwoButtonRowProps) => (
  <div className={['actionButtonsRow', className].filter(Boolean).join(' ')}>{children}</div>
);

interface IActionButtonsProps {
  productId?: number;
  isWarehouseLocation: boolean;
  isEditingForm: boolean;
  hasLastInspection: boolean;
  hasFormChanges: boolean;
  isGeneratingInspectionReportUrl: boolean;
  isUpdatingInspection?: boolean;
  handleClickDownloadInspection: () => void;
  onEditForm: () => void;
  onCancelChanges: () => void;
  onSaveChanges: () => void;
}

const ActionButtons = ({
  isWarehouseLocation,
  isEditingForm,
  hasLastInspection,
  productId,
  hasFormChanges,
  isGeneratingInspectionReportUrl,
  isUpdatingInspection,
  handleClickDownloadInspection,
  onEditForm,
  onCancelChanges,
  onSaveChanges
}: IActionButtonsProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleConfirmSave = () => {
    setIsModalOpen(false);
    onSaveChanges();
  };

  const renderEditButton = () => {
    if (isWarehouseLocation && !hasLastInspection && !isEditingForm) {
      return (
        <BordButton
          label="Editar información de la herramienta"
          onClick={onEditForm}
          disabled={Boolean(isUpdatingInspection || isGeneratingInspectionReportUrl)}
          buttonIconTwo="edit"
          customWidth='w-full'
        />
      );
    }

    if (!isWarehouseLocation && hasLastInspection)
      return (
        <BordButton
          label="Descargar últ. inspección"
          bordButtonStyle="outlined"
          onClick={handleClickDownloadInspection}
          disabled={Boolean(!productId || isGeneratingInspectionReportUrl)}
          buttonIconTwo="download"
          customWidth='w-full'
        />
      );

    if (!isEditingForm) {
      return (
        <TwoButtonRow>
          <BordButton
            label="Descargar últ. inspección"
            bordButtonStyle="outlined"
            onClick={handleClickDownloadInspection}
            disabled={Boolean(!productId || isGeneratingInspectionReportUrl)}
            buttonIconTwo="download"
            customWidth='w-full'
          />
          <BordButton
            label="Editar últ. inspección"
            onClick={onEditForm}
            disabled={Boolean(isGeneratingInspectionReportUrl)}
            buttonIconTwo="edit"
            customWidth='w-full'
          />
        </TwoButtonRow>
      );
    }

    return (
      <TwoButtonRow>
        <BordButton
          label="Cancelar modificación"
          bordButtonStyle="outlined"
          onClick={onCancelChanges}
          disabled={Boolean(isUpdatingInspection)}
          customWidth='w-full'
        />
        <BordButton
          label="Aplicar modificación"
          onClick={handleOpenModal}
          disabled={Boolean(isUpdatingInspection || !hasFormChanges)}
          customWidth='w-full'
        />
      </TwoButtonRow>
    );
  };

  return (
    <>
      <div className="toolInfoToolbar">{renderEditButton()}</div>

      {isModalOpen && (
        <ConfirmActionModal
          isOpen={isModalOpen}
          modalText="Al modificar la información de la herramienta, los cambios se actualizarán en WMS. ¿Deseas continuar?"
          firstButtonText="No, regresar"
          secondButtonText="Sí, aplicar modificación"
          onClose={handleCloseModal}
          onConfirm={handleConfirmSave}
          isLoading={isUpdatingInspection}
        />
      )}
    </>
  );
};

export default ActionButtons;
